export function initBfPercentAnimation(root: ParentNode = document): void {
  const containers = root.querySelectorAll<HTMLElement>('[data-bf-wave]');
  if (!containers.length) return;

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const easeOutCubic = (t: number) => 1 - Math.pow(1 - t, 3);

  for (const container of Array.from(containers)) {
    if (container.dataset.bfWaveInit === '1') continue;
    container.dataset.bfWaveInit = '1';

    const textPath = container.querySelector('textPath') as SVGTextPathElement | null;
    if (!textPath) continue;

    // Target value to center the text
    const to = 50; 

    // If reduced motion, set to final state immediately
    if (prefersReducedMotion) {
      textPath.setAttribute('startOffset', `${to}%`);
      continue;
    }

    const animateOnce = () => {
      let startTs: number | null = null;
      const durationMs = 1200;
      const from = -25; // Start off-screen left (adjusted for center anchor)
      
      const frame = (ts: number) => {
        if (startTs === null) startTs = ts;
        const elapsed = ts - startTs;
        const progress = Math.min(1, elapsed / durationMs);
        const eased = easeOutCubic(progress);
        const value = from + (to - from) * eased;
        textPath.setAttribute('startOffset', `${value}%`);
        if (progress < 1) requestAnimationFrame(frame);
      };

      requestAnimationFrame(frame);
    };

    const io = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            animateOnce();
            obs.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.2 }
    );

    io.observe(container);
  }
}
